import { iModalProps } from "@libs/modal-panels/modal-registry-model";

import { GenerateModalWithSuspense } from "@libs/modal-panels/modal-registry-helpers";
import React from "react";

const SimpleEmptyModal = React.lazy(() => import("./simple-empty.modal"));

const SimpleModal: iModalProps<
  typeof SimpleEmptyModal,
  {
    config: {
      title: string;
      icon: JSX.Element;
      content: JSX.Element;
    };
  }
> = {
  name: "simple-modal",
  component: GenerateModalWithSuspense(SimpleEmptyModal),
};

export default SimpleModal;
